import api from '@edu-fe/api'

export default {
  name: 'recharge',
  getInfo: (type) => api.create(`/order/coin/product?type=${type}`),
}
